const defaultScreenOptions = {
    cardStyle: {
        overflow: 'visible',
        flex: 1,
    },
    headerShown: false,
    animationTypeForReplace: 'pop',
};

export default defaultScreenOptions;
